module.exports = __webpack_public_path__ + "0f46a378921f6c3c78547ed1941a1f7a.jpg";